export default {
      id: "i-bear-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-bear",
      toString: function () {
        return this.url;
      }
    }